import TextFieldComponent from '../../shared/TextFieldComponent';
import { ENTER_INPUT } from '../../shared/AppConstants';
import { useFormContext } from 'react-hook-form';

export const LinkInputForm = ({ name, minRows }) => {
  const { control } = useFormContext();
  const label =
    name !== 'comment' ? name.charAt(0).toUpperCase() + name.slice(1) : '';

  return (
    <TextFieldComponent
      control={control}
      minRows={minRows}
      maxLength="512"
      placeholder={
        name !== 'comment' ? 'Ex: https://share.deere.com...' : ENTER_INPUT
      }
      name={name}
      label={label}
    />
  );
};
